import { render, staticRenderFns } from "./FreeKassaPayment.vue?vue&type=template&id=184110fd&scoped=true&"
import script from "./FreeKassaPayment.vue?vue&type=script&lang=js&"
export * from "./FreeKassaPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184110fd",
  null
  
)

export default component.exports